/**
 * Modifies Adyen payment content to customize behavior and add validation events
 * @param displayContent - The original HTML/JS content from CRT
 * @returns Modified content with customizations applied
 */
export const modifyAdyenContent = (displayContent: string): string => {
  let modifiedContent = displayContent.replace(
    /hasHolderName:\s*true/g,
    'hasHolderName: false',
  );
  modifiedContent = modifiedContent.replace(
    /holderNameRequired:\s*true/g,
    'holderNameRequired: false',
  );

  // Add VALIDATION_EVENT constant if not present
  if (!modifiedContent.includes('VALIDATION_EVENT')) {
    modifiedContent = modifiedContent.replace(
      /const HEIGHT_EVENT = ['"]msax-cc-height['"];/,
      `const HEIGHT_EVENT = 'msax-cc-height';\r\nconst VALIDATION_EVENT = 'msax-cc-validation';`,
    );
  }

  // Modify onChange to send validation postMessages (only if not already added)
  if (!modifiedContent.includes('postMessageToHost(VALIDATION_EVENT')) {
    // Inject validation postMessage right after paymentState = state;
    modifiedContent = modifiedContent.replace(
      /paymentState = state;/,
      `paymentState = state;\r\n            postMessageToHost(VALIDATION_EVENT, state.isValid || false);`,
    );
  }

  return modifiedContent;
};
